﻿/*import React from 'react';
import { Image_Props } from '@Util/Types';
import { str_isEmpty } from '@Util/Utils';

export default function ImageElement(props: Image_Props): JSX.Element {
    if (str_isEmpty(props.imageSrc)) {
        return <span>[NO IMAGESRC PROVIDED]</span>
    }

    function generateImageClass(): string {
        let classStr: string = "Image";

        if (!str_isEmpty(props.className)) {
            classStr += ` ${props.className}`;
        }

        return classStr;
    }

    function generateAspectRatio(): string {
        if (!str_isEmpty(props.aspectRatio)) {
            return props.aspectRatio;
        }

        const img: HTMLImageElement = new Image();
        img.src = props.imageSrc;

        img.onload = () => {
            const { naturalWidth, naturalHeight } = img;
            return `${naturalWidth}/${naturalHeight}`;
        };
    }

    return (
        <img
            className={generateImageClass()}
            src={props.imageSrc}
            alt={!str_isEmpty(props.imageAlt) ? props.imageAlt : ""}
            style={{ aspectRatio: generateAspectRatio() }}
        />
    );
}*/

import React, { useState, useEffect } from 'react';
import { Image_Props } from '@Util/Types';
import { str_isEmpty } from '@Util/Utils';

function generateImageClass(className: string): string {
    return `Image${!str_isEmpty(className) ? ` ${className}` : ''}`;
}

export default function ImageElement(props: Image_Props): JSX.Element {
    const [aspectRatio, setAspectRatio] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (!str_isEmpty(props.aspectRatio)) {
            setAspectRatio(props.aspectRatio);
        } else {
            const img = new Image();
            img.src = props.imageSrc;
            img.onload = () => {
                const { naturalWidth, naturalHeight } = img;
                setAspectRatio(`${naturalWidth}/${naturalHeight}`);
            };
        }
    }, [props.aspectRatio, props.imageSrc]);

    if (str_isEmpty(props.imageSrc)) {
        return <span>[NO IMAGESRC PROVIDED]</span>;
    }

    return (
        <img
            className={generateImageClass(props.className)}
            src={props.imageSrc}
            alt={!str_isEmpty(props.imageAlt) ? props.imageAlt : ""}
            style={{ aspectRatio }}
        />
    );
}